// TODO(koop): We should allow this id to be configurable.
export const HTML_ID = '​'; // zero-width space
export const SPECIFICITY_TOKEN = '__SPECIFICITY__';

//# sourceMappingURL=constants.js.map